import React from 'react';
import { useNavigate } from "react-router-dom";
import { Avatar, Col, Row, Card, Typography, Empty, Dropdown, Menu } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { formatCompanyLogoUrl } from '../../api/companyApi';
import usePortfolioActions from "./usePortfolioActions";
import './PortfolioSquare.css';

const { Title, Paragraph } = Typography;

const PortfolioSquare = ({ portfolio, width = 300, height = 220, maxLines = 6, theme = 'light',
    fontSize = '1.1em', actions = null }) => {

    const navigate = useNavigate();
    const logoUrl = formatCompanyLogoUrl();
    const description = portfolio.attr.summary ?? '';

    const { handlePortfolioAction } = usePortfolioActions({ portfolio });
    console.log(actions);

    // Dropdown menu for actions including "View Model"
    const actionMenu = (
        <Menu style={{background: 'rgba(255, 106, 106, 0.3)', backdropFilter: 'blur(10px)'}} onClick={({ key }) => {
            if (key === 'viewModel') {
                window.open(`/public/portfolio/${portfolio.id}`, '_blank');
            } else {
                handlePortfolioAction(key);
            }
        }}>
            <Menu.Item key="viewModel" style={{color: "#fff", fontWeight: '300'}}>
                VIEW THIS MODEL
            </Menu.Item>
            {actions && actions.map((actionItem, index) => (
                <Menu.Item key={actionItem.action} style={{color: "#fff", fontWeight: '300'}}>
                    {actionItem.label}
                </Menu.Item>
            ))}
        </Menu>
    );

    return (
        <Dropdown
            overlay={actionMenu}
            trigger={['hover']}
            placement="bottomCenter" // Popover placement
        >
            <Card
                className={`portfolio-square shadow-1 p-1 gapless ${theme}`}
                style={{ width, height }}
                bordered={false}
                hoverable // Adds hover effect to the card
            >
                <div className={'header'} style={{ height: height * 0.4, borderTopLeftRadius: '8px', borderTopRightRadius: '8px' }}>
                    <Row justify="space-between" align={'middle'} className={'px-2'} style={{ background: 'transparent' }}>
                        <Col>
                            <Avatar
                                src={logoUrl}
                                alt="Company Logo"
                                style={{ width: '100%', height: 50, borderRadius: '0' }}
                                preview={false}
                            />
                        </Col>
                        <Col>
                            <Typography.Title className={'pt-1'} level={4} style={{ color: '#fff' }}>
                                {portfolio?.targets?.equity} / {portfolio?.targets?.fixed}
                            </Typography.Title>
                        </Col>
                    </Row>

                    <div className={'title-wrapper'} style={{ marginTop: (height / 2) - height * 0.45 }}>
                        <div className="portfolio-title" style={{ color: "#fff" }}>
                            {portfolio.name}
                        </div>
                    </div>
                </div>

                <div style={{ height: height * 0.6, background: "transparent" }}>
                    <Row className={'py-3 px-2'} style={{ height: height / 2 * 0.7 }} justify={'center'}>
                        {description ? (
                            <Paragraph style={{
                                fontSize: '0.9em', fontFamily: "Roboto, sans-serif", color: "#fff",
                                fontWeight: '400', lineHeight: 2
                            }}
                                ellipsis={{ rows: maxLines, expandable: false }}
                            >
                                {description}
                            </Paragraph>
                        ) : <Empty
                            image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                            imageStyle={{
                                height: 45,
                            }}
                            description={
                                <Typography.Text>
                                    No <a href="#API">Description</a>
                                </Typography.Text>
                            }
                        />}
                    </Row>
                </div>
            </Card>
        </Dropdown>
    );
};

export default PortfolioSquare;
